/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable camelcase */
import PayTM from "assets/icons/glory/payment_paytm.svg";
import PhonePe from "assets/icons/glory/payment_phonepe.svg";
import GooglePay from "assets/icons/glory/payment_google.svg";
import CashOut from "assets/icons/bkash_cash_out.svg";
import SendMoney from "assets/icons/bkash_send_money.svg";
import MakePayment from "assets/icons/bkash_make_payment.svg";
import FailedIcon from "assets/icons/glory/payment_failed.svg";
import SuccessIcon from "assets/icons/glory/success.svg";
import WaitIcon from "assets/icons/glory/wait-status.svg";
import AttentionIcon from "assets/icons/glory/payment_attention.svg";
import NagadCashOut from "assets/icons/nagad_cash_out.svg";
import NagadSendMoney from "assets/icons/nagad_send_money.svg";
import NagadMerchantPay from "assets/icons/nagad_merchant_pay.svg";

import DenizBank from "assets/images/glory/bank_denizbank.webp";
import Kuveytturk from "assets/images/glory/bank_kuveyttürk.webp";
import Garanti from "assets/images/glory/bank_garanti.webp";
import Finansbank from "assets/images/glory/bank_finansbank.webp";
import Enpara from "assets/images/glory/bank_enpara.webp";
import TurkiyeFinans from "assets/images/glory/bank_turkiyeFinans.webp";
import ING from "assets/images/glory/bank_ing.webp";
import VakifBank from "assets/images/glory/bank_vakıfbank.webp";
import IsBank from "assets/images/glory/bank_bankası.webp";
import Akbank from "assets/images/glory/bank_akbank.webp";
import Sekerbank from "assets/images/glory/bank_sekerbank.webp";
import Halkbank from "assets/images/glory/bank_halkbank.webp";
import Odeabank from "assets/images/glory/bank_odeaBank.webp";
import Albaraka from "assets/images/glory/bank_albaraka.webp";
import Akifbank from "assets/images/glory/bank_aktifBank.webp";
import Anadolubank from "assets/images/glory/bank_anadolubank.webp";
import Teb from "assets/images/glory/bank_teb_bankasi.webp";
import KkapitalBank from "assets/images/glory/bank_kapitalbank.webp";
import Unibank from "assets/images/glory/bank_unibank.webp";
import AzerTurkBank from "assets/images/glory/bank_azerturkbank.webp";
import PASAbank from "assets/images/glory/bank_pasabank.webp";
import ExpressBank from "assets/images/glory/bank_expressbank.webp";
import BankRespublika from "assets/images/glory/bank_respublika.webp";
import BankOfBaku from "assets/images/glory/bank_bankofbaku.webp";
import YeloBank from "assets/images/glory/bank_yelobank.webp";
import GunaiBank from "assets/images/glory/bank_gunaibank.webp";
import TuranBank from "assets/images/glory/bank_turanbank.webp";
import RabitaBank from "assets/images/glory/bank_rabitabank.webp";
import AccessBank from "assets/images/glory/bank_accessbank.webp";
import XalqBank from "assets/images/glory/bank_xalqbank.webp";
import MuganBank from "assets/images/glory/bank_muganbank.webp";
import ABB from "assets/images/glory/bank_abb.webp";
import AFBbank from "assets/images/glory/bank_afbbank.webp";
import ASBbank from "assets/images/glory/bank_asbbank.webp";
import ZiraatBanksi from "assets/images/glory/bank_ziraatBankası.webp";
import Yapikredi from "assets/images/glory/bank_yapıkredi.webp";
import Leobank from "assets/images/glory/bank_leobank.webp";
import BTBbank from "assets/images/glory/bank_btbbank.webp";

import AllianceFinance from "assets/images/glory/bank_alliance_finance.webp";
import AllianceFinanceSmall from "assets/images/glory/bank_afc.webp";
import AmanaBankPLC from "assets/images/glory/bank_amana_bank.webp";
import AsiaAssetFinancePLC from "assets/images/glory/bank_asia_asset.webp";
import BimputhFinancePLC from "assets/images/glory/bank_bimputh_finance.webp";
import CBCFinanceLimited from "assets/images/glory/bank_cbc_finance.webp";
import CargillsBankLimited from "assets/images/glory/bank_cargills.webp";
import CentralFinancePLC from "assets/images/glory/bank_central_finance.webp";
import CitiBankNA from "assets/images/glory/bank_citi_bank.webp";
import CitizenDevelopmentBank from "assets/images/glory/bank_citizens_devvelopment.webp";
import CommercialBankPLC from "assets/images/glory/bank_commercial.webp";
import DFCCBankPLC from "assets/images/glory/bank_dfcc_bank.webp";
import DeutscheBankAG from "assets/images/glory/bank_deutsche.webp";
import DialogFinancePLC from "assets/images/glory/bank_dialog_finance.webp";
import HDFCBank from "assets/images/glory/bank_hdfc_bank.webp";
import HNBFinancePLC from "assets/images/glory/bank_hnb_finance.webp";
import HSBC from "assets/images/glory/bank_hsbc.webp";
import HabibBankLimited from "assets/images/glory/bank_habib_bank.webp";
import HattonNationalBankPLC from "assets/images/glory/bank_hatton_national.webp";
import IndianBank from "assets/images/glory/bank_indian_bank.webp";
import IndianOverseasBank from "assets/images/glory/bank_indian_overseas.webp";
import KanrichFinanceLimited from "assets/images/glory/bank_kanrich_finance.webp";
import LBFinancePLC from "assets/images/glory/bank_lb_finance.webp";
import LOLCDevelopmentFinance from "assets/images/glory/bank_lolc_development.webp";
import LOLCFinancePLC from "assets/images/glory/bank_lolc_finance.webp";
import LankaCreditFinanceLTD from "assets/images/glory/bank_lanka_credit_finance.webp";
import MCBBankLimited from "assets/images/glory/bank_mcb_bank_limited.webp";
import MercantileInvestments from "assets/images/glory/bank_mercantile_investments.webp";
import MerchantBankPLC from "assets/images/glory/bank_merchant_bank.webp";
import NationalDevelopmentBank from "assets/images/glory/bank_national_development.webp";
import NationalSavingsBank from "assets/images/glory/bank_national_savings.webp";
import PanAsiaBankPLC from "assets/images/glory/bank_pan_asia_bank.webp";
import PeopleLeasingFinance from "assets/images/glory/bank_people_lising_finance.webp";
import PolgahawelaCoOpBank from "assets/images/glory/bank_polgahawela_bank.webp";
import PeoplesBank from "assets/images/glory/bank_peoples_bank.webp";
import PublicBankBerhad from "assets/images/glory/bank_public_bank_berhad.webp";
import RegionalDevelopmentBank from "assets/images/glory/bank_regional_developments.webp";
import RichardPiersFinance from "assets/images/glory/bank_richard_pieris.webp";
import SampathBankPLC from "assets/images/glory/bank_sampath_bank.webp";
import SarvodhayaFinance from "assets/images/glory/bank_sarvodhaya_finance.webp";
import SenkadagalaFinancePLC from "assets/images/glory/bank_senkadagala_finance.webp";
import SeylanBankPLC from "assets/images/glory/bank_seylan_bank.webp";
import SingerFinancePLC from "assets/images/glory/bank_singer_finance.webp";
import StateMortgageBank from "assets/images/glory/bank_state_mortgage_bank.webp";
import UnionBankOfColomboPLC from "assets/images/glory/bank_union_of_colombo.webp";
import VallibelFinancePLC from "assets/images/glory/bank_vallibel_finance_plc.webp";
import SanasaDevelopmentBank from "assets/images/glory/bank_sansa_development.webp";
import FintrexFinanceLimited from "assets/images/glory/bank_fintrex_finance.webp";
import AirtelPaymentsBankLtd from "assets/images/glory/bank_Airtel_Payments.webp";
import AxisBank from "assets/images/glory/bank_Axis_Bank.webp";
import BandhanBankLimited from "assets/images/glory/bank_Bandhan_Bank.webp";
import BankOfAmerica from "assets/images/glory/bank_Bank_of_America.webp";
import BankOfBahrainAndKuwaitBSC from "assets/images/glory/bank_Bank_of_Bahrain_and_Kuwait.webp";
import BankOfBaroda from "assets/images/glory/bank_Bank_of_Baroda.webp";
import BankOfIndia from "assets/images/glory/bank_Bank_of_India.webp";
import BankOfMaharashtra from "assets/images/glory/bank_Bank_of_Maharashtra.webp";
import BarclaysBank from "assets/images/glory/bank_Barclays_Bank.webp";
import BNPParibas from "assets/images/glory/bank_BNP_Paribas.webp";
import CanaraBank from "assets/images/glory/bank_Canara_Bank.webp";
import CatholicSyrianBank from "assets/images/glory/bank_Catholic_Syrian_Bank.webp";
import CentralBankOfIndia from "assets/images/glory/bank_central_bank_of_india.webp";
import CitiBank from "assets/images/glory/bank_Citi.webp";
import CityUnionBank from "assets/images/glory/bank_City_Union_Bank.webp";
import CreditAgricoleCorporateInvestmentBank from "assets/images/glory/bank_Credit_Agricole_CIB.webp";
import DCBankLtd from "assets/images/glory/bank_Development_Credit_Bank.webp";
import DevelopmentBankOfSingapore from "assets/images/glory/bank_development_bank_of_singapore.webp";
import DhanalakshmiBank from "assets/images/glory/bank_Dhanlaxmi_Bank.webp";
import EmiratesNBDBankPJSC from "assets/images/glory/bank_EMIRATESNBD.webp";
import FederalBank from "assets/images/glory/bank_Federal_Bank.webp";
import Fibabank from "assets/images/glory/bank_fibabanka.webp";
import FinoPaymentsBank from "assets/images/glory/bank_Fino_Bank.webp";
import ICICIBank from "assets/images/glory/bank_ICICI_Bank.webp";
import HSBC_i from "assets/images/glory/bank_HSBC_i.webp";
import HDFCBank_i from "assets/images/glory/bank_HDFC_Bank_i.webp";
import IDBIBank from "assets/images/glory/bank_idbi_bank.webp";
import IDFCBank from "assets/images/glory/bank_IDFC_First_Bank.webp";
import IndiaPostPaymentsBankLimited from "assets/images/glory/bank_India_Post_Payments_bank_Limited.webp";
import IndianOverseasBank_i from "assets/images/glory/bank_Indian_Overseas_i.webp";
import IndusindBank from "assets/images/glory/bank_IndusInd_Bank.webp";
import JammuAndKashmirBank from "assets/images/glory/bank_Jammu_&_Kashmir_Bank.webp";
import JIOPaymentsBank from "assets/images/glory/bank_Jio_payments.webp";
import KarnatakaBank from "assets/images/glory/bank_Karnataka_Bank.webp";
import KarurVysyaBank from "assets/images/glory/bank_Karur_Vysya_Bank.webp";
import KhardahCooperativeBankLtd from "assets/images/glory/bank_khardah.webp";
import KotakMahindraBank from "assets/images/glory/bank_Kotak_Mahindra_Group.webp";
import NSDLPaymentsBankLtd from "assets/images/glory/bank_NSDL.webp";
import PaytmPaymentsBank from "assets/images/glory/bank_Paytm_payments_bank.webp";
import PunjabAndSindBank from "assets/images/glory/bank_Punjab_and_Sind_Bank.webp";
import PunjabNationalBank from "assets/images/glory/bank_Punjab_National_Bank.webp";
import RamrajyaSahakariBankLtd from "assets/images/glory/bank_Ramrajya_Sahakari_Bank_Ltd.webp";
import RatnakarBank from "assets/images/glory/bank_Ratnakar_Bank_RBL.webp";
import SBMBankIndiaLimited from "assets/images/glory/bank_SBM_BANK_INDIA_LIMITED.webp";
import ShinhanBank from "assets/images/glory/bank_Shinhan_Bank.webp";
import SriSatyaSaiNagrikSahakariBankMydt from "assets/images/glory/bank_Sri_Satya_Sai_Nagrik_Sahakari_Bank_Mydt.webp";
import SouthIndianBank from "assets/images/glory/bank_South_Indian_Bank.webp";
import StandardCharteredBank_i from "assets/images/glory/bank_Standard_Chartered_i.webp";
import StateBankOfIndia_i from "assets/images/glory/bank_State_Bank_of_India_i.webp";
import TamilnadMercantileBank from "assets/images/glory/bank_TMB.webp";
import TheGoaUrbanCooperativeBankLtd from "assets/images/glory/bank_The_Goa_Urban_Co_Operative_Bank_Ltd.webp";
import TheRayatSevakCooperativeBankLimited from "assets/images/glory/bank_The_Rayat_Sevak_Co_Operative_Bank_Limited.webp";
import TirumalaCooperativeUrbanBankLtd from "assets/images/glory/bank_Tirumala_Co_operative_Urban_Bank_Ltd.webp";
import UCOBank from "assets/images/glory/bank_UCO_Bank.webp";
import UnionBankOfIndia from "assets/images/glory/bank_Union_Bank_of_India.webp";
import YesBankLtd from "assets/images/glory/bank_Yes_Bank.webp";
import ZiiratKatlim from "assets/images/glory/bank_zaiiratkatlim.webp";
import Alternatif from "assets/images/glory/bank_alternatif.webp";
import BurganBank from "assets/images/glory/bank_burgan.webp";

import AgriBank from "assets/images/glory/bank_agribank.webp";
import AciaCommercial from "assets/images/glory/bank_asia_commercial_bank.webp";
import BIDV from "assets/images/glory/bank_BIDV.webp";
import DongaBank from "assets/images/glory/bank_donga.webp";
import Eximbank from "assets/images/glory/bank_eximbank.webp";
import Sacombank from "assets/images/glory/bank_sacombank.webp";
import Techcombank from "assets/images/glory/bank_techcombank.webp";
import Vietcombank from "assets/images/glory/bank_vietcombank.webp";
import Vietinbank from "assets/images/glory/bank_vietinbank.webp";

import Jeju from "assets/images/glory/bank_jeju.webp";
import Busan from "assets/images/glory/bank_busan.webp";
import Citibank from "assets/images/glory/bank_citibank.webp";
import CreditUnion from "assets/images/glory/bank_credit_union.webp";
import Daegu from "assets/images/glory/bank_daegu.webp";
import Savings from "assets/images/glory/bank_dmsgod_mutual_savings.webp";
import IBKBank from "assets/images/glory/bank_IBK.webp";
import Jeonbuk from "assets/images/glory/bank_jeonbuk.webp";
import KBank from "assets/images/glory/bank_K.webp";
import Kakao from "assets/images/glory/bank_kakao.webp";
import KDB from "assets/images/glory/bank_KDB.webp";
import KEB from "assets/images/glory/bank_KEB.webp";
import KEBHana from "assets/images/glory/bank_KEB_hana.webp";
import Kwanguju from "assets/images/glory/bank_kwangju.webp";
import Kyongnam from "assets/images/glory/bank_KYONGNAM.webp";
import Kyungnam from "assets/images/glory/bank_kyungnam.webp";
import Nacufok from "assets/images/glory/bank_NACUFOK.webp";
import Agricultural from "assets/images/glory/bank_national_agricultural_cooperative_federation.webp";
import NH from "assets/images/glory/bank_NH.webp";
import Nonghyup from "assets/images/glory/bank_nonghyup.webp";
import Post from "assets/images/glory/bank_post.webp";
import Saemaeul from "assets/images/glory/bank_saemaeul.webp";
import SC from "assets/images/glory/bank_SC.webp";
import Shinhan from "assets/images/glory/bank_shinhan.webp";
import Suhyup from "assets/images/glory/bank_suhyup.webp";
import Toss from "assets/images/glory/bank_toss.webp";
import Woori from "assets/images/glory/bank_woori.webp";

import { SelectOptionProps } from "components/atoms/Select";
import {
  BANKS_TRY_ENUM,
  PaymentAppsType,
  PAYMENT_APPS,
  BANKS_LKR_ENUM,
  BANKS_INR_ENUM,
  ANINDA_HAVALE_BANK,
  BANKS_AZ_ENUM,
  BANKS_MAKSIPARA_ENUM,
  BANKS_VIETNAM_ENUM,
  BANKS_SPAYZ_ENUM,
  BANKS_VIETNAM_PAYOK_ENUM,
  BANKS_BOVA_ENUM,
  MPAY_BANKS_TRY_ENUM,
  SMARTPROPAY_BANKS_TRY_ENUM,
} from "types/PaymentMethodsTypes";

export enum PAYMENT_METHODS_CODES {
  ANINDA_HAVALE = "pm.simple_pay.aninda_havale",
  AZARPAY = "pm.azarpay.azarpay",
  AZARPAY_VALERPAY = "pm.valerpay.credit_card",
  BANK_CARDS_TRY = "pm.bank.cards.try",
  BANKTRANSFER = "pm.paykassma.banktransfer_manual",
  BKASH = "pm.paykassma.bkashp2p",
  BKASH_P2C = "pm.paykassma.bkashp2c",
  CEB_BANK = "pm.ceb.bank",
  CONSTANTPOS = "pm.constantpos",
  COREFY = "pm.corefy.bank_cards",
  CC = "pm.mpay.credit_card",
  TROY = "pm.troy.credit_card",
  EASYPAISA = "pm.paykassma.easypaisa",
  EPUL = "pm.epul.uzcard",
  EXPAY = "pm.expay.expay",
  EXPRESS_HAVALE = "pm.simple_pay.express_havale",
  HAVALE_VIP = "pm.simple_pay_vip_havale",
  HAVALE_HERA = "pm.havale_payhera.bank-transfer",
  IPAY = "pm.paykassma.ipay_manual",
  // eslint-disable-next-line @typescript-eslint/no-shadow
  IMPS = "pm.paykassma.imps",
  CP_IMPS = "pm.constantpos.imps",
  ZenpayIMPS = "pm.zenpay.imps",
  JAZZCASH_PAYKASSMA = "pm.paykassma.jazzcash",
  INSTAKK = "pm.simple_pay.instakk",
  JAZZCASH = "pm.jazzcash.jazzcash",
  KPAY = "pm.paykassma.kpay",
  MEFETE = "pm.simple_pay.mefete",
  MPESA = "pm.paykassma.mpesa",
  NAGAD = "pm.paykassma.nagadp2p",
  NAGAD_P2C = "pm.paykassma.nagadp2c",
  PAPARA = "pm.simple_pay_papara",
  PAYCOS = "pm.paycos.base",
  PAYFIX = "pm.payturka.payfix",
  PAYHERA = "pm.payhera.payhera",
  ROCKET = "pm.paykassma.rocket",
  TEST = "pm.test.testmethod",
  UPAY = "pm.paykassma.upay_manual",
  UPIS = "pm.paykassma.upis",
  UPIV_GOOGLE = "pm.apay.upi_fast_v.googlepay",
  UPIV_PHONEPE = "pm.apay.upi_fast_v.phonpe",
  WAVEPAY = "pm.paykassma.wavepay",
  PAYTM = "pm.paykassma.paytm",
  UPI_W = "pm.paykassma.upi_w",
  UPI_L = "pm.paykassma.upi_l",
  UPI_M = "pm.paykassma.upi_m",
  UPI_IB = "pm.paykassma.upi_ib",
  UPI_HB = "pm.paykassma.upi_hb",
  UPI_IN = "pm.paykassma.upi_in",
  PHONEPE = "pm.paykassma.phone_pe",
  WP_BKASH = "pm.wellxpay.bkash",
  WP_NAGAD = "pm.wellxpay.nagad",
  CONSTANTPOS_GOOGLEPAY = "pm.constantpos.upi.googlepay",
  CONSTANTPOS_PHONEPE = "pm.constantpos.upi.phonpe",
  REFERRAL = "pm.referral",
  MANUAL = "pm.manual",
  BONUS = "pm.bonus",
  CONSTANTPOS_PAYTM = "pm.constantpos.upi.paytm",
  ZENPAY_GOOGLEPAY = "pm.zenpay.upi.googlepay",
  ZENPAY_PHONEPE = "pm.zenpay.upi.phonepe",
  ZENPAY_PAYTM = "pm.zenpay.upi.paytm",
  CASHIX_BKASH = "pm.cashix.bkash_p2c",
  CASHIX_NAGAD = "pm.cashix.nagad_p2c",
  APAY_BKASH = "pm.apay.bkash_a",
  APAY_NAGAD = "pm.apay.nagad_a",
  AP_IMPS = "pm.apay.imps",
  VALERPAY_M10 = "pm.valerpay.m10",
  VALERPAY_MPAY = "pm.valerpay.mpay",
  SMARTPROPAY_M10 = "pm.smartpropay.m10",
  SMARTPROPAY_MPAY = "pm.smartpropay.mpay",
  MAKSIPARA_BANKTRANSFER = "pm.maksipara.bank_transfer",
  MAKSIPARA_PEPPARA = "pm.maksipara.peppara",
  MAKSIPARA_PAPARA = "pm.maksipara.papara",
  MAKSIPARA_PAYFIX = "pm.maksipara.payfix",
  MAKSIPARA_POPYPARA = "pm.maksipara.popypara",
  MAKSIPARA_PAYBOL = "pm.maksipara.paybol",
  ESEWA = "pm.apay.esewa",
  KHALTI = "pm.apay.khalti",
  AP_UPAY = "pm.apay.upay",
  AP_JAZZCASH = "pm.apay.jazzcash",
  AP_EASYPAISA = "pm.apay.easypaisa",
  AP_BANKALFALAH = "pm.apay.bankalfalah",
  OCTOPAYS_NAGAD = "pm.octopays.nagad",
  OCTOPAYS_BKASH = "pm.octopays.bkash",
  CASHIX_VIETQR = "pm.cashix.viet_qr",
  CASHIX_MOMOPAY = "pm.cashix.momo_pay",
  VVP_KREDIKARTI = "pm.vevopay.kredikarti",
  BITOLO_MOMOPAY = "pm.bitolo.momopay",
  BITOLO_ZALOPAY = "pm.bitolo.zalopay",
  BITOLO_VIETTELPAY = "pm.bitolo.viettelpay",
  BITOLO_BANKTRANSFER = "pm.bitolo.bank_transfer",
  BITOLO_VIETQR = "pm.bitolo.viet_qr",
  WANGUPAY_MOMOPAY = "pm.wangupay.momo_pay",
  WANGUPAY_VIET_QR = "pm.wangupay.viet_qr",
  SPAYZ_BANKTRANSFER = "pm.spayz.bank_transfer",
  SPAYZ_VIRTUALACCOUNT = "pm.spayz.virtual_account",
  UMMONEY_KHALTI = "pm.um_money.khalti",
  UMMONEY_ESEWA = "pm.um_money.esewa",
  UMMONEY_CELLPAY = "pm.um_money.cellpay",
  UMMONEY_IMEPAY = "pm.um_money.imepay",
  EASYPAYGAME_JAZZCASH = "pm.easy_pay_game.jazzcash",
  EASYPAYGAME_EASYPAISA = "pm.easy_pay_game.easypaisa",
  PAYOK_MOMOPAY = "pm.payok.momo_pay",
  PAYOK_VIET_QR = "pm.payok.mb_viet_qr",
  PAYOK_VIETCOM_QR = "pm.payok.vietcom_qr",
  PAYOK_TECHCOM_VIET_QR = "pm.payok.techcom_viet_qr",
  PAYOK_ACB_VIET_QR = "pm.payok.acb_viet_qr",
  PAYOK_BIDV_QR = "pm.payok.bidv_qr",
  PAYOK_VIETTEL_PAY = "pm.payok.viettel_pay",
  PAYOK_BANKTRANSFER = "pm.payok.bank_transfer",
  INWIZO_EMANAT = "pm.inwizo.emanat",
  INWIZO_M10 = "pm.inwizo.m10",
  INWIZO_M10_ACCOUNT = "pm.inwizo.m10_wallet",
  INWIZO_M10_BANKS = "pm.inwizo.m10_bank_card",
  COREFY_NAGAD = "pm.corefy.nagad",
  COREFY_BKASH = "pm.corefy.bkash",
  OCTOPAYS_NAGAD_P2P = "pm.octopays.nagad_p2p",
  OCTOPAYS_BKASH_P2P = "pm.octopays.bkash_p2p",
  BOVA_BANKTRANSFER = "pm.bova.bank_transfer",
  CRYPTO_PROCESSING = "pm.crypto.processing",
  BOVA_CLICKTOSS = "pm.bova.click_toss",
  MPAY_HAVALE_FAST = "pm.mpay.havale_fast_iban",
  MPAY_HAVALE = "pm.mpay.havale",
  FLASHPAY_KAKAOPAY = "pm.flash_pay.kakao_pay",
  FLASHPAY_NAVERPAY = "pm.flash_pay.naver_pay",
  VEVOPAY_HIZLIHAVALE = "pm.vevopay.hizli_havale",
  CASHIX_EASYPAISA = "pm.cashix.easy_paisa",
  CASHIX_JAZZCASH = "pm.cashix.jazz_cash",
  APAY_NAYAPAY = "pm.apay.naya-pay",
  BETATRANSFER_BANKTRANSFET = "pm.beta_transfer.bank_transfer",
  SMARTPROPAY_HAVALEFAST = "pm.smartpropay.havale_fast",
  DZENPAY_EASYPAISA = "pm.dzen_pay.easy_paisa",
  DZENPAY_JUZZCASH = "pm.dzen_pay.jazz_cash",
  ZOVI_EASYPAISA = "pm.zovi.easy_paisa",
}

export const UPI_PAYMENT_APPS: PaymentAppsType[] = [
  {
    id: PAYMENT_APPS.PAYTM,
    appName: "PayTM",
    appLogo: PayTM,
    prefix: "paytmmp://",
  },
  {
    id: PAYMENT_APPS.PHONEPE,
    appName: "PhonePe",
    appLogo: PhonePe,
    prefix: "phonepe://",
  },
  {
    id: PAYMENT_APPS.GOOGLE_PAY,
    appName: "Google Pay",
    appLogo: GooglePay,
    prefix: "tez://upi/",
  },
];
export const BANKS_LKR: SelectOptionProps[] = [
  {
    id: BANKS_LKR_ENUM.AllianceFinance,
    name: "Alliance Finance Company PLC",
    image: window.innerWidth > 768 ? AllianceFinanceSmall : AllianceFinance,
  },
  {
    id: BANKS_LKR_ENUM.AmanaBankPLC,
    name: "Amana Bank PLC",
    image: AmanaBankPLC,
  },
  {
    id: BANKS_LKR_ENUM.AsiaAssetFinancePLC,
    name: "Asia Asset Finance PLC",
    image: AsiaAssetFinancePLC,
  },
  {
    id: BANKS_LKR_ENUM.BimputhFinancePLC,
    name: "Bimputh Finance PLC",
    image: BimputhFinancePLC,
  },
  {
    id: BANKS_LKR_ENUM.CBCFinanceLimited,
    name: "CBC Finance Limited",
    image: CBCFinanceLimited,
  },
  {
    id: BANKS_LKR_ENUM.CargillsBankLimited,
    name: "Cargills Bank Limited",
    image: CargillsBankLimited,
  },
  {
    id: BANKS_LKR_ENUM.CentralFinancePLC,
    name: "Central Finance PLC",
    image: CentralFinancePLC,
  },
  { id: BANKS_LKR_ENUM.CitiBankNA, name: "Citi bank N. A.", image: CitiBankNA },
  {
    id: BANKS_LKR_ENUM.CitizenDevelopmentBank,
    name: "Citizen Development Bank",
    image: CitizenDevelopmentBank,
  },
  {
    id: BANKS_LKR_ENUM.CommercialBankPLC,
    name: "Commercial Bank PLC",
    image: CommercialBankPLC,
  },
  { id: BANKS_LKR_ENUM.DFCCBankPLC, name: "DFCC Bank PLC", image: DFCCBankPLC },
  {
    id: BANKS_LKR_ENUM.DeutscheBankAG,
    name: "Deutsche Bank AG",
    image: DeutscheBankAG,
  },
  {
    id: BANKS_LKR_ENUM.DialogFinancePLC,
    name: "Dialog Finance PLC",
    image: DialogFinancePLC,
  },
  { id: BANKS_LKR_ENUM.HDFCBank, name: "HDFC Bank", image: HDFCBank },
  {
    id: BANKS_LKR_ENUM.HNBFinancePLC,
    name: "HNB Finance PLC",
    image: HNBFinancePLC,
  },
  { id: BANKS_LKR_ENUM.HSBC, name: "HSBC", image: HSBC },
  {
    id: BANKS_LKR_ENUM.HabibBankLimited,
    name: "Habib Bank Limited",
    image: HabibBankLimited,
  },
  {
    id: BANKS_LKR_ENUM.HattonNationalBankPLC,
    name: "Hatton National Bank PLC",
    image: HattonNationalBankPLC,
  },
  { id: BANKS_LKR_ENUM.IndianBank, name: "Indian Bank", image: IndianBank },
  {
    id: BANKS_LKR_ENUM.IndianOverseasBank,
    name: "Indian Overseas Bank",
    image: IndianOverseasBank,
  },
  {
    id: BANKS_LKR_ENUM.KanrichFinanceLimited,
    name: "Kanrich Finance Limited",
    image: KanrichFinanceLimited,
  },
  {
    id: BANKS_LKR_ENUM.LBFinancePLC,
    name: "L B Finance PLC",
    image: LBFinancePLC,
  },
  {
    id: BANKS_LKR_ENUM.LOLCDevelopmentFinance,
    name: "LOLC Development Finance",
    image: LOLCDevelopmentFinance,
  },
  {
    id: BANKS_LKR_ENUM.LOLCFinancePLC,
    name: "LOLC Finance PLC",
    image: LOLCFinancePLC,
  },
  {
    id: BANKS_LKR_ENUM.LankaCreditFinanceLTD,
    name: "Lanka Credit Finance LTD",
    image: LankaCreditFinanceLTD,
  },
  {
    id: BANKS_LKR_ENUM.MCBBankLimited,
    name: "MCB Bank Limited",
    image: MCBBankLimited,
  },
  {
    id: BANKS_LKR_ENUM.MercantileInvestments,
    name: "Mercantile Investments",
    image: MercantileInvestments,
  },
  {
    id: BANKS_LKR_ENUM.MerchantBankPLC,
    name: "Merchant Bank PLC",
    image: MerchantBankPLC,
  },
  {
    id: BANKS_LKR_ENUM.NationalDevelopmentBank,
    name: "National Development Bank",
    image: NationalDevelopmentBank,
  },
  {
    id: BANKS_LKR_ENUM.NationalSavingsBank,
    name: "National Savings Bank",
    image: NationalSavingsBank,
  },
  {
    id: BANKS_LKR_ENUM.PanAsiaBankPLC,
    name: "Pan Asia Bank PLC",
    image: PanAsiaBankPLC,
  },
  {
    id: BANKS_LKR_ENUM.PeopleLeasingFinance,
    name: "People Leasing Finance",
    image: PeopleLeasingFinance,
  },
  {
    id: BANKS_LKR_ENUM.PolgahawelaCoOpBank,
    name: "Polgahawela Co-op Bank",
    image: PolgahawelaCoOpBank,
  },
  { id: BANKS_LKR_ENUM.PeoplesBank, name: "Peoples Bank", image: PeoplesBank },
  {
    id: BANKS_LKR_ENUM.PublicBankBerhad,
    name: "Public Bank Berhad",
    image: PublicBankBerhad,
  },
  {
    id: BANKS_LKR_ENUM.RegionalDevelopmentBank,
    name: "Regional Development Bank",
    image: RegionalDevelopmentBank,
  },
  {
    id: BANKS_LKR_ENUM.RichardPiersFinance,
    name: "Richard Piers Finance",
    image: RichardPiersFinance,
  },
  {
    id: BANKS_LKR_ENUM.SampathBankPLC,
    name: "Sampath Bank PLC",
    image: SampathBankPLC,
  },
  {
    id: BANKS_LKR_ENUM.SarvodhayaFinance,
    name: "Sarvodhaya Finance",
    image: SarvodhayaFinance,
  },
  {
    id: BANKS_LKR_ENUM.SenkadagalaFinancePLC,
    name: "Senkadagala Finance PLC",
    image: SenkadagalaFinancePLC,
  },
  {
    id: BANKS_LKR_ENUM.SeylanBankPLC,
    name: "Seylan Bank PLC",
    image: SeylanBankPLC,
  },
  {
    id: BANKS_LKR_ENUM.SingerFinancePLC,
    name: "Singer Finance PLC",
    image: SingerFinancePLC,
  },
  {
    id: BANKS_LKR_ENUM.StateMortgageBank,
    name: "State Mortgage Bank",
    image: StateMortgageBank,
  },
  {
    id: BANKS_LKR_ENUM.UnionBankOfColomboPLC,
    name: "Union Bank Of Colombo PLC",
    image: UnionBankOfColomboPLC,
  },
  {
    id: BANKS_LKR_ENUM.VallibelFinancePLC,
    name: "Vallibel Finance PLC",
    image: VallibelFinancePLC,
  },
  {
    id: BANKS_LKR_ENUM.SanasaDevelopmentBank,
    name: "Sanasa Development Bank",
    image: SanasaDevelopmentBank,
  },
  {
    id: BANKS_LKR_ENUM.FintrexFinanceLimited,
    name: "Fintrex Finance Limited",
    image: FintrexFinanceLimited,
  },
];

export const BANKS_TRY_HAVALE: SelectOptionProps[] = [
  {
    id: BANKS_TRY_ENUM.AKBANK,
    name: "Akbank",
    image: Akbank,
  },
  {
    id: BANKS_TRY_ENUM.ISBANK,
    name: "İş bankası",
    image: IsBank,
  },
  {
    id: BANKS_TRY_ENUM.TURKIYE_FINANS,
    name: "Türkiye Finans",
    image: TurkiyeFinans,
  },
  {
    id: BANKS_TRY_ENUM.FINANSBANK,
    name: "Qnb Finans",
    image: Finansbank,
  },
  {
    id: BANKS_TRY_ENUM.KUVEYTTURK,
    name: "Kuveyt Türk",
    image: Kuveytturk,
  },
  {
    id: BANKS_TRY_ENUM.GARANTI_BANKASI,
    name: "Garanti",
    image: Garanti,
  },
  {
    id: BANKS_TRY_ENUM.ZIRAAT_BANKASI,
    name: "Ziraat Bankası",
    image: ZiraatBanksi,
  },
  {
    id: BANKS_TRY_ENUM.TEB,
    name: "TEB",
    image: Teb,
  },
  {
    id: BANKS_TRY_ENUM.DENIZBANK,
    name: "Deniz BANK",
    image: DenizBank,
  },
  {
    id: BANKS_TRY_ENUM.YAPIKREDI,
    name: "YapıKredi",
    image: Yapikredi,
  },
  {
    id: BANKS_TRY_ENUM.HALKBANK,
    name: "Halkbank",
    image: Halkbank,
  },
  {
    id: BANKS_TRY_ENUM.ENPARA,
    name: "ENPARA",
    image: Enpara,
  },
  {
    id: BANKS_TRY_ENUM.ING,
    name: "ING",
    image: ING,
  },
  {
    id: BANKS_TRY_ENUM.VAKIFBANK,
    name: "VakıfBank",
    image: VakifBank,
  },
  {
    id: BANKS_TRY_ENUM.FIBABANKA,
    name: "Fibabank",
    image: Fibabank,
  },
];

export const BANKS_TRY: SelectOptionProps[] = [
  {
    id: BANKS_TRY_ENUM.AKBANK,
    name: "Akbank",
    image: Akbank,
  },
  {
    id: BANKS_TRY_ENUM.AKTIFBANK,
    name: "Aktifbank",
    image: Akifbank,
  },
  {
    id: BANKS_TRY_ENUM.ALBARAKA_TURK,
    name: "Albaraka Türk",
    image: Albaraka,
  },
  {
    id: BANKS_TRY_ENUM.ALTERNATIF_BANK,
    name: "Alternatif Bank",
    image: Alternatif,
  },
  {
    id: BANKS_TRY_ENUM.ANADOLUBANK,
    name: "Anadolubank",
    image: Anadolubank,
  },
  {
    id: BANKS_TRY_ENUM.BURGAN_BANK,
    name: "Burgan Bank",
    image: BurganBank,
  },
  {
    id: BANKS_TRY_ENUM.DENIZBANK,
    name: "Denizbank",
    image: DenizBank,
  },
  {
    id: BANKS_TRY_ENUM.ENPARA,
    name: "Enpara",
    image: Enpara,
  },
  {
    id: BANKS_TRY_ENUM.FINANSBANK,
    name: "Finansbank",
    image: Finansbank,
  },
  {
    id: BANKS_TRY_ENUM.GARANTI_BANKASI,
    name: "Garanti Bankası",
    image: Garanti,
  },
  {
    id: BANKS_TRY_ENUM.HSBC_BANK,
    name: "HSBC Bank",
    image: HSBC_i,
  },
  {
    id: BANKS_TRY_ENUM.HALKBANK,
    name: "Halkbank",
    image: Halkbank,
  },
  {
    id: BANKS_TRY_ENUM.ING,
    name: "ING",
    image: ING,
  },
  {
    id: BANKS_TRY_ENUM.ISBANK,
    name: "İş Bankası",
    image: IsBank,
  },
  {
    id: BANKS_TRY_ENUM.KUVEYTTURK,
    name: "Kuveyttürk",
    image: Kuveytturk,
  },
  {
    id: BANKS_TRY_ENUM.ODEABANK,
    name: "OdeaBank",
    image: Odeabank,
  },
  {
    id: BANKS_TRY_ENUM.SEKERBANK,
    name: "Şekerbank",
    image: Sekerbank,
  },
  {
    id: BANKS_TRY_ENUM.TEB,
    name: "TEB",
    image: Teb,
  },
  {
    id: BANKS_TRY_ENUM.TURKIYE_FINANS,
    name: "Türkiye Finans",
    image: TurkiyeFinans,
  },
  {
    id: BANKS_TRY_ENUM.VAKIFBANK,
    name: "VakıfBank",
    image: VakifBank,
  },
  {
    id: BANKS_TRY_ENUM.YAPIKREDI,
    name: "Yapıkredi",
    image: Yapikredi,
  },
  {
    id: BANKS_TRY_ENUM.ZIRAAT_BANKASI,
    name: "Ziraat Bankası",
    image: ZiraatBanksi,
  },
  {
    id: BANKS_TRY_ENUM.ZIRAAT_KATLIM,
    name: "Ziraat Katılım",
    image: ZiiratKatlim,
  },
  {
    id: BANKS_TRY_ENUM.FIBABANKA,
    name: "Fibabank",
    image: Fibabank,
  },
];

export const BANKS_AZ: SelectOptionProps[] = [
  {
    id: BANKS_AZ_ENUM.UNIBANK,
    name: "Unibank",
    image: Unibank,
  },
  {
    id: BANKS_AZ_ENUM.AZERTURKBANK,
    name: "Azər Turk Bank",
    image: AzerTurkBank,
  },
  {
    id: BANKS_AZ_ENUM.PASABANK,
    name: "PASA Bank",
    image: PASAbank,
  },
  {
    id: BANKS_AZ_ENUM.EXPRESSBANK,
    name: "Express Bank",
    image: ExpressBank,
  },
  {
    id: BANKS_AZ_ENUM.BANKRESPUBLIKA,
    name: "Bank Respublika",
    image: BankRespublika,
  },
  {
    id: BANKS_AZ_ENUM.BANKOFAKU,
    name: "Bank of Baku",
    image: BankOfBaku,
  },
  {
    id: BANKS_AZ_ENUM.YELOBANK,
    name: "YeloBank",
    image: YeloBank,
  },
  {
    id: BANKS_AZ_ENUM.GUNAYBANK,
    name: "Gunay Bank",
    image: GunaiBank,
  },
  {
    id: BANKS_AZ_ENUM.TURANBANK,
    name: "Turanbank",
    image: TuranBank,
  },
  {
    id: BANKS_AZ_ENUM.RABITABANK,
    name: "Rabitəbank",
    image: RabitaBank,
  },
  {
    id: BANKS_AZ_ENUM.ACCESSBANK,
    name: "AccessBank",
    image: AccessBank,
  },
  {
    id: BANKS_AZ_ENUM.XALQBANK,
    name: "Xalq Bank",
    image: XalqBank,
  },
  {
    id: BANKS_AZ_ENUM.MUGANBANK,
    name: "MuganBank",
    image: MuganBank,
  },
  {
    id: BANKS_AZ_ENUM.ABB,
    name: "ABB",
    image: ABB,
  },
  {
    id: BANKS_AZ_ENUM.AFBBANK,
    name: "AFB Bank",
    image: AFBbank,
  },
  {
    id: BANKS_AZ_ENUM.ASBBANK,
    name: "ASB Bank",
    image: ASBbank,
  },
  {
    id: BANKS_AZ_ENUM.ZIRAATBANKAZE,
    name: "Ziraat Bank Aze",
    image: ZiraatBanksi,
  },
  {
    id: BANKS_AZ_ENUM.YAPIKREDIBANKAZE,
    name: "Yapi Kedi Bank Aze",
    image: Yapikredi,
  },
  {
    id: BANKS_AZ_ENUM.BANKBTB,
    name: "Bank BTB",
    image: BTBbank,
  },
  {
    id: BANKS_AZ_ENUM.LEOBANK,
    name: "Leobank",
    image: Leobank,
  },
  {
    id: BANKS_AZ_ENUM.KAPITALBANK,
    name: "Kapitalbank",
    image: KkapitalBank,
  },
];

export const ANINDA_HAVALE_BANKS_TRY: SelectOptionProps[] = [
  {
    id: ANINDA_HAVALE_BANK.GarantiBankasi,
    name: "Garanti Bankası",
    image: Garanti,
  },
  {
    id: ANINDA_HAVALE_BANK.Akbank,
    name: "Akbank",
    image: Akbank,
  },
  {
    id: ANINDA_HAVALE_BANK.DenizBank,
    name: "Denizbank",
    image: DenizBank,
  },
  {
    id: ANINDA_HAVALE_BANK.FinansBank,
    name: "Finansbank",
    image: Finansbank,
  },
  {
    id: ANINDA_HAVALE_BANK.IsBankasi,
    name: "İş Bankası",
    image: IsBank,
  },
  {
    id: ANINDA_HAVALE_BANK.Teb,
    name: "TEB",
    image: Teb,
  },
  {
    id: ANINDA_HAVALE_BANK.Vakifbank,
    name: "VakıfBank",
    image: VakifBank,
  },
  {
    id: ANINDA_HAVALE_BANK.YapiKredi,
    name: "Yapıkredi",
    image: Yapikredi,
  },
  {
    id: ANINDA_HAVALE_BANK.ZiraatBankasi,
    name: "Ziraat Bankası",
    image: ZiraatBanksi,
  },
  {
    id: ANINDA_HAVALE_BANK.IngBank,
    name: "ING",
    image: ING,
  },
  {
    id: ANINDA_HAVALE_BANK.Sekerbank,
    name: "Şekerbank",
    image: Sekerbank,
  },
  {
    id: ANINDA_HAVALE_BANK.KuveytTurk,
    name: "Kuveyttürk",
    image: Kuveytturk,
  },
  {
    id: ANINDA_HAVALE_BANK.TurkiyeFinans,
    name: "Türkiye Finans",
    image: TurkiyeFinans,
  },
  {
    id: ANINDA_HAVALE_BANK.Halkbank,
    name: "Halkbank",
    image: Halkbank,
  },
  {
    id: ANINDA_HAVALE_BANK.AlbarakaTurk,
    name: "Albaraka Türk",
    image: Albaraka,
  },
  {
    id: ANINDA_HAVALE_BANK.Enpara,
    name: "Enpara",
    image: Enpara,
  },
];

export const MPAY_HAVALE_BANKS_TRY: SelectOptionProps[] = [
  { id: MPAY_BANKS_TRY_ENUM.FAST_EFT, name: "FAST EFT" },
  { id: MPAY_BANKS_TRY_ENUM.VAKIF_KATILIM, name: "Vakıf Katılım" },
  { id: MPAY_BANKS_TRY_ENUM.TURKIYE_FINANS, name: "Turkiye Finans" },
  { id: MPAY_BANKS_TRY_ENUM.TEB, name: "TEB" },
  { id: MPAY_BANKS_TRY_ENUM.GARANTI_BANKASI, name: "Garanti Bankası" },
  { id: MPAY_BANKS_TRY_ENUM.KUVEYTTURK, name: "Kuveyt Türk" },
  { id: MPAY_BANKS_TRY_ENUM.ZIRAAT_BANKASI, name: "Ziraat Bankası" },
  { id: MPAY_BANKS_TRY_ENUM.AKBANK, name: "Akbank" },
  { id: MPAY_BANKS_TRY_ENUM.HALKBANK, name: "Halkbank" },
  { id: MPAY_BANKS_TRY_ENUM.ISBANK, name: "İş Bankası" },
  { id: MPAY_BANKS_TRY_ENUM.FIBABANKA, name: "Fibabank" },
  { id: MPAY_BANKS_TRY_ENUM.ALBARAKA_TURK, name: "Albaraka Türk" },
  { id: MPAY_BANKS_TRY_ENUM.ING, name: "ING Bank" },
  { id: MPAY_BANKS_TRY_ENUM.ZIRAAT_KATLIM, name: "Ziraat Katılım" },
  { id: MPAY_BANKS_TRY_ENUM.DENIZBANK, name: "Denizbank" },
  { id: MPAY_BANKS_TRY_ENUM.ODEABANK, name: "Odea Bank" },
  { id: MPAY_BANKS_TRY_ENUM.VAKIFBANK, name: "Vakıfbank" },
  { id: MPAY_BANKS_TRY_ENUM.SEKERBANK, name: "Şekerbank" },
  { id: MPAY_BANKS_TRY_ENUM.YAPIKREDI, name: "Yapı Kredi" },
  { id: MPAY_BANKS_TRY_ENUM.FINANSBANK, name: "Finansbank / Enpara" },
];

export const SMARTPROPAY_HAVALE_BANKS_TRY: SelectOptionProps[] = [
  {
    id: SMARTPROPAY_BANKS_TRY_ENUM.ZIRAAT_BANKASI,
    name: "T.C. Ziraat Bankası A.Ş.",
  },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.HALKBANK, name: "Halk Bankası A.Ş." },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.VAKIFBANK, name: "VakıfBank" },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.AKBANK, name: "Akbank T.A.Ş." },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.TEB, name: "TEB" },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.SEKERBANK, name: "Şekerbank T.A.Ş." },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.ISBANK, name: "İş Bankası A.Ş." },
  {
    id: SMARTPROPAY_BANKS_TRY_ENUM.YAPIKREDI,
    name: "Yapı ve Kredi Bankası A.Ş.",
  },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.ENPARA, name: "Enpara" },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.DENIZBANK, name: "Denizbank A.Ş." },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.FINANSBANK, name: "QNB Finans Bank A.Ş." },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.HSBC, name: "HSBC Bank A.Ş." },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.ING, name: "ING Bank A.Ş." },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.ODEABANK, name: "Odea Bank A.Ş." },
  {
    id: SMARTPROPAY_BANKS_TRY_ENUM.GARANTI_BANKASI,
    name: "Garanti Bankası A.Ş.",
  },
  {
    id: SMARTPROPAY_BANKS_TRY_ENUM.ALBARAKA_TURK,
    name: "Albaraka Türk Katılım Bankası",
  },
  {
    id: SMARTPROPAY_BANKS_TRY_ENUM.KUVEYTTURK,
    name: "Kuveyt Türk Katılım Bankası",
  },
  {
    id: SMARTPROPAY_BANKS_TRY_ENUM.TURKIYE_FINANS,
    name: "Türkiye Finans Katılım Bankası",
  },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.PTTBANK, name: "Ptt Bank" },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.BURGANBANK, name: "BurganBank" },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.FIBABANKA, name: "Fibabanka" },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.AKTIF_BANK, name: "Aktif Bank" },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.ALTERNATIF_BANK, name: "Alternatif Bank" },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.FAST_BANK, name: "Fast Bank" },
  { id: SMARTPROPAY_BANKS_TRY_ENUM.FASTBANK_ALT, name: "Fastbank" },
];

export const BANKS_TRY_HAVALE_VIP: SelectOptionProps[] = [
  {
    id: BANKS_TRY_ENUM.AKBANK,
    name: "AKBANK",
    image: Akbank,
  },
  {
    id: BANKS_TRY_ENUM.DENIZBANK,
    name: "DENİZBANK",
    image: DenizBank,
  },
  {
    id: BANKS_TRY_ENUM.GARANTI_BANKASI,
    name: "GARANTİ BANKASI",
    image: Garanti,
  },
  {
    id: BANKS_TRY_ENUM.FINANSBANK,
    name: "FİNANSBANK",
    image: Finansbank,
  },
  {
    id: BANKS_TRY_ENUM.ING,
    name: "İNG",
    image: ING,
  },
  {
    id: BANKS_TRY_ENUM.ISBANK,
    name: "İŞ BANKASI",
    image: IsBank,
  },
  {
    id: BANKS_TRY_ENUM.KUVEYTTURK,
    name: "KUVEYTTÜRK",
    image: Kuveytturk,
  },
  {
    id: BANKS_TRY_ENUM.TEB,
    name: "TEB",
    image: Teb,
  },
  {
    id: BANKS_TRY_ENUM.TURKIYE_FINANS,
    name: "Türkiye Finans",
    image: TurkiyeFinans,
  },
  {
    id: BANKS_TRY_ENUM.VAKIFBANK,
    name: "VAKIFBANK",
    image: VakifBank,
  },
  {
    id: BANKS_TRY_ENUM.YAPIKREDI,
    name: "YAPI KREDİ",
    image: Yapikredi,
  },
  {
    id: BANKS_TRY_ENUM.ZIRAAT_BANKASI,
    name: "ZİRAAT BANKASI",
    image: ZiraatBanksi,
  },
];

export const BANKS_BOVA: SelectOptionProps[] = [
  { id: BANKS_BOVA_ENUM.ABN_AMRO, name: "ABN Amro" },
  { id: BANKS_BOVA_ENUM.BANK_OF_AMERICA, name: "Bank of America" },
  { id: BANKS_BOVA_ENUM.BNK_SECURITIES_CO, name: "BNK Securities Co" },
  { id: BANKS_BOVA_ENUM.BNP_PARIBAS, name: "BNP Paribas" },
  { id: BANKS_BOVA_ENUM.BNP_PKR, name: "BNPPKR" },
  { id: BANKS_BOVA_ENUM.BOOKOOK, name: "Bookook" },
  { id: BANKS_BOVA_ENUM.BANK_OF_KOREA, name: "Bank of Korea" },
  { id: BANKS_BOVA_ENUM.BARCLAYS, name: "Barclays" },
  { id: BANKS_BOVA_ENUM.BUSAN_BANK, name: "Busan Bank" },
  {
    id: BANKS_BOVA_ENUM.CHINA_CONSTRUCTION_BANK,
    name: "China Construction Bank",
  },
  { id: BANKS_BOVA_ENUM.CITIBANK_KOREA, name: "Citibank Korea" },
  { id: BANKS_BOVA_ENUM.CREDIT_UNION, name: "Credit Union" },
  { id: BANKS_BOVA_ENUM.DAESHIN, name: "Daeshin" },
  {
    id: BANKS_BOVA_ENUM.DB_FINANCIAL_INVESTMENT_CO_LTD,
    name: "DB Financial Investment Co Ltd",
  },
  { id: BANKS_BOVA_ENUM.DEUTSCHE_BANK, name: "Deutsche Bank" },
  { id: BANKS_BOVA_ENUM.DMS_BANK, name: "DMS Bank" },
  { id: BANKS_BOVA_ENUM.DAEGU_BANK, name: "Daegu Bank" },
  { id: BANKS_BOVA_ENUM.HANKOOK, name: "Hankook" },
  { id: BANKS_BOVA_ENUM.HANWHA, name: "Hanwha" },
  { id: BANKS_BOVA_ENUM.HITOOJA, name: "Hitooja" },
  { id: BANKS_BOVA_ENUM.HSBC, name: "HSBC" },
  {
    id: BANKS_BOVA_ENUM.HANA_FINANCIAL_INVESTMENT,
    name: "Hana Financial Investment",
  },
  {
    id: BANKS_BOVA_ENUM.HYUNDAI_MOTOR_SECURITIES,
    name: "Hyundai Motor Securities",
  },
  { id: BANKS_BOVA_ENUM.IBK, name: "IBK" },
  { id: BANKS_BOVA_ENUM.ING, name: "ING" },
  {
    id: BANKS_BOVA_ENUM.INDUSTRIAL_COMMERCIAL_BANK_OF_CHINA,
    name: "Industrial Commercial Bank of China",
  },
  { id: BANKS_BOVA_ENUM.JPMORGAN_CHASE, name: "JPMorgan Chase" },
  { id: BANKS_BOVA_ENUM.JEJU_BANK, name: "Jeju Bank" },
  { id: BANKS_BOVA_ENUM.JEONBUK_BANK, name: "Jeonbuk Bank" },
  { id: BANKS_BOVA_ENUM.K_BANK, name: "K Bank" },
  { id: BANKS_BOVA_ENUM.KB_SECURITIES, name: "KB Securities" },
  { id: BANKS_BOVA_ENUM.KDB, name: "KDB" },
  { id: BANKS_BOVA_ENUM.KEB_HANA_BANK, name: "KEB Hana Bank" },
  { id: BANKS_BOVA_ENUM.KIWOOM, name: "Kiwoom" },
  {
    id: BANKS_BOVA_ENUM.KOREAN_FEDERATION_OF_COMMUNITY_CREDIT_COOPERATIVES,
    name: "Korean Federation of Community Credit Cooperatives",
  },
  { id: BANKS_BOVA_ENUM.KTB_INVESTMENT, name: "KTB Investment" },
  { id: BANKS_BOVA_ENUM.KYOBO_TRADE, name: "Kyobo Trade" },
  { id: BANKS_BOVA_ENUM.KAKAO_BANK, name: "Kakao Bank" },
  { id: BANKS_BOVA_ENUM.KOOKMIN_BANK, name: "Kookmin Bank" },
  {
    id: BANKS_BOVA_ENUM.KOREA_DEVELOPMENT_BANK,
    name: "Korea Development Bank",
  },
  { id: BANKS_BOVA_ENUM.KOREA_FOSS_SECURITIES, name: "Korea Foss Securities" },
  { id: BANKS_BOVA_ENUM.KWANGJU_BANK, name: "Kwangju Bank" },
  { id: BANKS_BOVA_ENUM.KYUNGNAM_BANK, name: "Kyungnam Bank" },
  { id: BANKS_BOVA_ENUM.MERITZ, name: "Meritz" },
  { id: BANKS_BOVA_ENUM.MIRAEASSET_DAEWOO, name: "MiraeAsset Daewoo" },
  { id: BANKS_BOVA_ENUM.NH_INVESTMENT, name: "NH Investment" },
  {
    id: BANKS_BOVA_ENUM.NATIONAL_AGRICULTURAL_COOPERATIVE_FEDERATION,
    name: "National Agricultural Cooperative Federation",
  },
  { id: BANKS_BOVA_ENUM.NONGHYUP_BANK, name: "Nonghyup Bank" },
  { id: BANKS_BOVA_ENUM.POST_BANK, name: "Post Bank" },
  { id: BANKS_BOVA_ENUM.SAMSUNG, name: "Samsung" },
  { id: BANKS_BOVA_ENUM.SANLIM, name: "Sanlim" },
  { id: BANKS_BOVA_ENUM.SC_FIRST_BANK, name: "SC First Bank" },
  { id: BANKS_BOVA_ENUM.SHINYOUNG, name: "Shinyoung" },
  { id: BANKS_BOVA_ENUM.SKTRADE, name: "SKTrade" },
  { id: BANKS_BOVA_ENUM.SAEMAEUL_BANK, name: "Saemaeul Bank" },
  { id: BANKS_BOVA_ENUM.SHINHAN_BANK, name: "Shinhan Bank" },
  {
    id: BANKS_BOVA_ENUM.SHINHAN_INVESTMENT_CORP,
    name: "Shinhan Investment Corp",
  },
  {
    id: BANKS_BOVA_ENUM.STANDARD_CHARTERED_BANK,
    name: "Standard Chartered Bank",
  },
  { id: BANKS_BOVA_ENUM.SUHYUP_BANK, name: "Suhyup Bank" },
  { id: BANKS_BOVA_ENUM.WOORI_BANK, name: "Woori Bank" },
  { id: BANKS_BOVA_ENUM.YOUJIN_TRADE, name: "Youjin Trade" },
  { id: BANKS_BOVA_ENUM.YUANTA, name: "Yuanta" },
  {
    id: BANKS_BOVA_ENUM.DMSGOD_MUTUAL_SAVINGS_BANK,
    name: "dmsgod Mutual Savings Bank",
  },
  {
    id: BANKS_BOVA_ENUM.EBEST_INVESTMENT_SECURITIES_CO_LTD,
    name: "eBest Investment Securities Co Ltd",
  },
  { id: BANKS_BOVA_ENUM.KAKAOPAY_SECURITIES, name: "Kakaopay Securities" },
  { id: BANKS_BOVA_ENUM.TOSS, name: "Toss" },
  { id: BANKS_BOVA_ENUM.TOSS_SEC, name: "Toss Sec" },
  { id: BANKS_BOVA_ENUM.NATIONAL_CREDIT_UNION, name: "National Credit Union" },
  { id: BANKS_BOVA_ENUM.DAISHIN, name: "Daishin" },
  { id: BANKS_BOVA_ENUM.KISEUROPE, name: "KISEurope" },
  { id: BANKS_BOVA_ENUM.HANVA_INVEST, name: "Hanva Invest" },
  { id: BANKS_BOVA_ENUM.KIWOOM_SEC, name: "Kiwoom Sec" },
  { id: BANKS_BOVA_ENUM.KFCC, name: "KFCC" },
  { id: BANKS_BOVA_ENUM.DAOLSECURITIES, name: "DaolSecurities" },
  { id: BANKS_BOVA_ENUM.WOORIIB, name: "WooriIB" },
  { id: BANKS_BOVA_ENUM.SAMSUNGSECURITIES, name: "SamsungSecurities" },
  { id: BANKS_BOVA_ENUM.SYFUND, name: "SYFund" },
  { id: BANKS_BOVA_ENUM.LS_SEC, name: "LS Sec" },
];

export const BANKS_MAKSIPARA: SelectOptionProps[] = [
  {
    id: BANKS_MAKSIPARA_ENUM.AKBANK,
    name: "Akbank",
    image: Akbank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.ALBARAKA,
    name: "Albaraka",
    image: Albaraka,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.ANADOLU_BANK,
    name: "Anadolu Bank",
    image: Anadolubank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.BURGANBANK,
    name: "Burganbank",
    image: BurganBank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.DENIZBANK,
    name: "Denizbank",
    image: DenizBank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.ENPARA,
    name: "Enpara",
    image: Enpara,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.FIBABANK,
    name: "Fibabank",
    image: Fibabank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.GARANTI_BANKASI,
    name: "Garanti Bankası",
    image: Garanti,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.HALKBANK,
    name: "Halkbank",
    image: Halkbank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.ING_BANK,
    name: "ING Bank",
    image: ING,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.IS_BANKASI,
    name: "İş Bankası",
    image: IsBank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.KUVEYT_TURK,
    name: "Kuveyt Türk",
    image: Kuveytturk,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.ODEABANK,
    name: "Odeabank",
    image: Odeabank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.QNB_FINANSBANK,
    name: "QNB Finansbank",
    image: Finansbank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.SEKERBANK,
    name: "Şekerbank",
    image: Sekerbank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.TEB,
    name: "TEB",
    image: Teb,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.TURKIYE_FINANS,
    name: "Türkiye Finans",
    image: TurkiyeFinans,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.VAKIFBANK,
    name: "Vakıfbank",
    image: VakifBank,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.YAPI_KREDI,
    name: "Yapı Kredi",
    image: Yapikredi,
  },
  {
    id: BANKS_MAKSIPARA_ENUM.ZIRAAT_BANKASI,
    name: "Ziraat Bankası",
    image: ZiraatBanksi,
  },
];

export const BANKS_INR: SelectOptionProps[] = [
  {
    id: BANKS_INR_ENUM.AirtelPaymentsBankLtd,
    name: "Airtel Payments Bank Ltd.",
    image: AirtelPaymentsBankLtd,
  },
  { id: BANKS_INR_ENUM.AxisBank, name: "Axis Bank", image: AxisBank },
  {
    id: BANKS_INR_ENUM.BandhanBankLimited,
    name: "Bandhan Bank limited",
    image: BandhanBankLimited,
  },
  {
    id: BANKS_INR_ENUM.BankOfAmerica,
    name: "Bank of America",
    image: BankOfAmerica,
  },
  {
    id: BANKS_INR_ENUM.BankOfBahrainAndKuwaitBSC,
    name: "Bank of Bahrain and Kuwait B.S.C",
    image: BankOfBahrainAndKuwaitBSC,
  },
  {
    id: BANKS_INR_ENUM.BankOfBaroda,
    name: "Bank of Baroda",
    image: BankOfBaroda,
  },
  { id: BANKS_INR_ENUM.BankOfIndia, name: "Bank of India", image: BankOfIndia },
  {
    id: BANKS_INR_ENUM.BankOfMaharashtra,
    name: "Bank of Maharashtra",
    image: BankOfMaharashtra,
  },
  {
    id: BANKS_INR_ENUM.BarclaysBank,
    name: "Barclays Bank",
    image: BarclaysBank,
  },
  { id: BANKS_INR_ENUM.BNPParibas, name: "BNP Paribas", image: BNPParibas },
  { id: BANKS_INR_ENUM.CanaraBank, name: "Canara Bank", image: CanaraBank },
  {
    id: BANKS_INR_ENUM.CatholicSyrianBank,
    name: "Catholic Syrian Bank",
    image: CatholicSyrianBank,
  },
  {
    id: BANKS_INR_ENUM.CentralBankOfIndia,
    name: "Central Bank of India",
    image: CentralBankOfIndia,
  },
  { id: BANKS_INR_ENUM.CitiBank, name: "Citi bank", image: CitiBank },
  {
    id: BANKS_INR_ENUM.CityUnionBank,
    name: "City Union Bank",
    image: CityUnionBank,
  },
  {
    id: BANKS_INR_ENUM.CreditAgricoleCorporateInvestmentBank,
    name: "Credit Agricole Corporate & Investment Bank",
    image: CreditAgricoleCorporateInvestmentBank,
  },
  { id: BANKS_INR_ENUM.DCBankLtd, name: "DCB Bank Ltd.", image: DCBankLtd },
  {
    id: BANKS_INR_ENUM.DevelopmentBankOfSingapore,
    name: "Development Bank of Singapore",
    image: DevelopmentBankOfSingapore,
  },
  {
    id: BANKS_INR_ENUM.DhanalakshmiBank,
    name: "Dhanalakshmi Bank",
    image: DhanalakshmiBank,
  },
  {
    id: BANKS_INR_ENUM.EmiratesNBDBankPJSC,
    name: "Emirates NBD Bank (P J S C)",
    image: EmiratesNBDBankPJSC,
  },
  { id: BANKS_INR_ENUM.FederalBank, name: "Federal Bank", image: FederalBank },
  {
    id: BANKS_INR_ENUM.FinoPaymentsBank,
    name: "Fino Payments Bank",
    image: FinoPaymentsBank,
  },
  { id: BANKS_INR_ENUM.ICICIBank, name: "ICICI Bank", image: ICICIBank },
  { id: BANKS_INR_ENUM.HSBC, name: "HSBC", image: HSBC_i },
  { id: BANKS_INR_ENUM.HDFCBank, name: "HDFC Bank", image: HDFCBank_i },
  { id: BANKS_INR_ENUM.IDBIBank, name: "IDBI Bank", image: IDBIBank },
  { id: BANKS_INR_ENUM.IDFCBank, name: "IDFC bank", image: IDFCBank },
  {
    id: BANKS_INR_ENUM.IndiaPostPaymentsBankLimited,
    name: "India Post Payments bank Limited",
    image: IndiaPostPaymentsBankLimited,
  },
  { id: BANKS_INR_ENUM.IndianBank, name: "Indian Bank", image: IndianBank },
  {
    id: BANKS_INR_ENUM.IndianOverseasBank,
    name: "Indian Overseas Bank",
    image: IndianOverseasBank_i,
  },
  {
    id: BANKS_INR_ENUM.IndusindBank,
    name: "Indusind Bank",
    image: IndusindBank,
  },
  {
    id: BANKS_INR_ENUM.JammuAndKashmirBank,
    name: "Jammu And Kashmir Bank",
    image: JammuAndKashmirBank,
  },
  {
    id: BANKS_INR_ENUM.JIOPaymentsBank,
    name: "JIO Payments Bank",
    image: JIOPaymentsBank,
  },
  {
    id: BANKS_INR_ENUM.KarnatakaBank,
    name: "Karnataka Bank",
    image: KarnatakaBank,
  },
  {
    id: BANKS_INR_ENUM.KarurVysyaBank,
    name: "Karur Vysya Bank",
    image: KarurVysyaBank,
  },
  {
    id: BANKS_INR_ENUM.KhardahCooperativeBankLtd,
    name: "Khardah Cooperative Bank Ltd",
    image: KhardahCooperativeBankLtd,
  },
  {
    id: BANKS_INR_ENUM.KotakMahindraBank,
    name: "Kotak Mahindra Bank",
    image: KotakMahindraBank,
  },
  {
    id: BANKS_INR_ENUM.NSDLPaymentsBankLtd,
    name: "NSDL PAYMENTS BANK LTD",
    image: NSDLPaymentsBankLtd,
  },
  {
    id: BANKS_INR_ENUM.PaytmPaymentsBank,
    name: "Paytm Payments Bank",
    image: PaytmPaymentsBank,
  },
  {
    id: BANKS_INR_ENUM.PunjabAndSindBank,
    name: "Punjab and Sind Bank",
    image: PunjabAndSindBank,
  },
  {
    id: BANKS_INR_ENUM.PunjabNationalBank,
    name: "Punjab National Bank",
    image: PunjabNationalBank,
  },
  {
    id: BANKS_INR_ENUM.RamrajyaSahakariBankLtd,
    name: "RAMRAJYA SAHAKARI BANK LTD",
    image: RamrajyaSahakariBankLtd,
  },
  {
    id: BANKS_INR_ENUM.RatnakarBank,
    name: "Ratnakar Bank",
    image: RatnakarBank,
  },
  {
    id: BANKS_INR_ENUM.SBMBankIndiaLimited,
    name: "SBM BANK (INDIA) LIMITED",
    image: SBMBankIndiaLimited,
  },
  { id: BANKS_INR_ENUM.ShinhanBank, name: "Shinhan Bank", image: ShinhanBank },
  {
    id: BANKS_INR_ENUM.SriSatyaSaiNagrikSahakariBankMydt,
    name: "SRI SATYA SAI NAGRIK SAHAKARI BANK, MYDT",
    image: SriSatyaSaiNagrikSahakariBankMydt,
  },
  {
    id: BANKS_INR_ENUM.SouthIndianBank,
    name: "South Indian Bank",
    image: SouthIndianBank,
  },
  {
    id: BANKS_INR_ENUM.StandardCharteredBank,
    name: "Standard Chartered Bank",
    image: StandardCharteredBank_i,
  },
  {
    id: BANKS_INR_ENUM.StateBankOfIndia,
    name: "State Bank of India",
    image: StateBankOfIndia_i,
  },
  {
    id: BANKS_INR_ENUM.TamilnadMercantileBank,
    name: "Tamilnad Mercantile Bank",
    image: TamilnadMercantileBank,
  },
  {
    id: BANKS_INR_ENUM.TheGoaUrbanCooperativeBankLtd,
    name: "The Goa Urban Co-Operative Bank Ltd.",
    image: TheGoaUrbanCooperativeBankLtd,
  },
  {
    id: BANKS_INR_ENUM.TheRayatSevakCooperativeBankLimited,
    name: "The Rayat Sevak Co-Operative Bank Limited",
    image: TheRayatSevakCooperativeBankLimited,
  },
  {
    id: BANKS_INR_ENUM.TirumalaCooperativeUrbanBankLtd,
    name: "TIRUMALA CO-OPERATIVE URBAN BANK LTD",
    image: TirumalaCooperativeUrbanBankLtd,
  },
  { id: BANKS_INR_ENUM.UCOBank, name: "UCO Bank", image: UCOBank },
  {
    id: BANKS_INR_ENUM.UnionBankOfIndia,
    name: "Union Bank Of India",
    image: UnionBankOfIndia,
  },
  { id: BANKS_INR_ENUM.YesBankLtd, name: "Yes Bank Ltd", image: YesBankLtd },
];

export const BANKS_VND: SelectOptionProps[] = [
  {
    id: BANKS_VIETNAM_ENUM.TECHCOMBANK,
    code: "TCB",
    name: "Techcombank",
    image: Techcombank,
  },
  {
    id: BANKS_VIETNAM_ENUM.SACOMBANK,
    code: "SCM",
    name: "Sacombank",
    image: Sacombank,
  },
  {
    id: BANKS_VIETNAM_ENUM.VIETCOMBANK,
    code: "VCB",
    name: "Vietcombank",
    image: Vietcombank,
  },
  {
    id: BANKS_VIETNAM_ENUM.ASIACOMMERCIAL,
    code: "ACB",
    name: "Asia Commercial Bank",
    image: AciaCommercial,
  },
  {
    id: BANKS_VIETNAM_ENUM.DONGABANK,
    code: "DAB",
    name: "DongA Bank",
    image: DongaBank,
  },
  {
    id: BANKS_VIETNAM_ENUM.VIETINBANK,
    code: "VTB",
    name: "Vietin Bank",
    image: Vietinbank,
  },
  {
    id: BANKS_VIETNAM_ENUM.BIDVBANK,
    code: "BIDV",
    name: "Bank for Investment and Development of Vietnam",
    image: BIDV,
  },
  {
    id: BANKS_VIETNAM_ENUM.EXIMBANK,
    code: "EXIM",
    name: "Eximbank Vietnam",
    image: Eximbank,
  },
  {
    id: BANKS_VIETNAM_ENUM.AGRIBANK,
    code: "VBARD",
    name: "AGRI BANK",
    image: AgriBank,
  },
];

export const BANKS_VND_PAYOK: SelectOptionProps[] = [
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.ABBANK,
    code: "970425",
    name: "ABBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.ACB,
    code: "970416",
    name: "ACB",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.AGRIBANK,
    code: "970405",
    name: "AgriBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VIETCAPITALBANK,
    code: "970454",
    name: "VietcapitalBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.BAOVIETBANK,
    code: "970438",
    name: "BaoVietBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.BIDV,
    code: "970418",
    name: "BIDV",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.DONGABANK,
    code: "970406",
    name: "DongABank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.EXIMBANK,
    code: "970431",
    name: "Eximbank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.GPBANK,
    code: "970408",
    name: "GPBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.HDBANK,
    code: "970437",
    name: "HDBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.HONGLEONGBANK,
    code: "970442",
    name: "Hongleong Bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.INDOVINA,
    code: "970434",
    name: "Indovina",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.KIENLONGBANK,
    code: "970452",
    name: "KienLongBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.LIENVIETPOSTBANK,
    code: "970449",
    name: "LienVietPostBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.MARITIMEBANK,
    code: "970426",
    name: "Maritime Bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.MBBANK,
    code: "970422",
    name: "MBBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.NAVIBANK,
    code: "970419",
    name: "Navibank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.OCB,
    code: "970448",
    name: "OCB",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.OCEANBANK,
    code: "970414",
    name: "OceanBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.PGBANK,
    code: "970430",
    name: "PG Bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.PVCOMBANK,
    code: "970412",
    name: "PVCombank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.SACOMBANK,
    code: "970403",
    name: "Sacombank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.SAIGONBANK,
    code: "970400",
    name: "SaigonBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.SCB,
    code: "970429",
    name: "SCB",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.SEABANK,
    code: "970440",
    name: "SeABank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.SHB,
    code: "970443",
    name: "SHB",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.SHINHANBANK,
    code: "970424",
    name: "Shinhan Bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.TECHCOMBANK,
    code: "970407",
    name: "Techcombank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.TPBANK,
    code: "970423",
    name: "TPBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.UOB,
    code: "970458",
    name: "UOB",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VIETCOMBANK,
    code: "970436",
    name: "VietcomBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VIBBANK,
    code: "970441",
    name: "VIB Bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.PUBLICBANK,
    code: "970439",
    name: "Public bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VIETABANK,
    code: "970427",
    name: "VietABank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VIETBANK,
    code: "970433",
    name: "VietBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VIETINBANK,
    code: "970415",
    name: "VietinBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VPBANK,
    code: "970432",
    name: "VPBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VIETNAMRUSSIABANK,
    code: "970421",
    name: "VietNam - Russia Bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.WOORIBANK,
    code: "970457",
    name: "Woori bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.BACABANK,
    code: "970409",
    name: "BacABank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.NAMABANK,
    code: "970428",
    name: "NamA bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.CIMB,
    code: "422589",
    name: "CIMB",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.NONGHYUPBANKHN,
    code: "801011",
    name: "Nonghyup Bank - HN",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.DBSHCM,
    code: "796500",
    name: "DBS - HCM",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.COOPBANK,
    code: "970446",
    name: "Co op Bank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.HSBC,
    code: "458761",
    name: "HSBC",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.CAKE,
    code: "546034",
    name: "CAKE",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.UBANK,
    code: "546035",
    name: "Ubank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.MHB,
    code: "970401",
    name: "MHB",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.STANDARDCHARTERED,
    code: "970410",
    name: "Standard Chartered",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.CBBANK,
    code: "970444",
    name: "CBBank",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.IBKHANOI,
    code: "970455",
    name: "IBK - Ha Noi",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.IBKHCM,
    code: "970456",
    name: "IBK HCM",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.KOOKMINHN,
    code: "970462",
    name: "Kookmin - HN",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VIETCREDIT,
    code: "970460",
    name: "VietCredit",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.MIRAEASSET,
    code: "970468",
    name: "Mirae Asset",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.KEBHANAHCM,
    code: "970466",
    name: "Keb Hana - Ho Chi Minh",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.KEBHANAHN,
    code: "970467",
    name: "Keb Hana - Ha Noi",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.KOOKMINHCM,
    code: "970463",
    name: "Kookmin - HCM",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.KBANKHCM,
    code: "668888",
    name: "KBank - HCM",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VIETTELMONEY,
    code: "971005",
    name: "ViettelMoney",
    image: "",
  },
  {
    id: BANKS_VIETNAM_PAYOK_ENUM.VNPTMONEY,
    code: "971011",
    name: "VNPTMoney",
    image: "",
  },
];

export const BKASH_ACCOUNT_TYPE = {
  agent: {
    title: "CASH OUT",
    icon: <CashOut />,
  },
  personal: {
    title: "SEND MONEY",
    icon: <SendMoney />,
  },
  merchant: {
    title: "MAKE PAYMENT",
    icon: <MakePayment />,
  },
};

export const PAYTM_ACCOUNT_TYPE = {
  agent: {
    title: "CASH OUT",
    icon: <CashOut />,
  },
  personal: {
    title: "SEND MONEY",
    icon: <SendMoney />,
  },
  merchant: {
    title: "MAKE PAYMENT",
    icon: <MakePayment />,
  },
};

export const NAGAD_ACCOUNT_TYPE = {
  agent: {
    title: "CASH OUT",
    icon: <NagadCashOut />,
  },
  personal: {
    title: "SEND MONEY",
    icon: <NagadSendMoney />,
  },
  merchant: {
    title: "MERCHANT PAY",
    icon: <NagadMerchantPay />,
  },
};

export const SUCCESS_PAGE = {
  icon: <SuccessIcon />,
  header: "popup.payment.success.title",
  application: "popup.payment.success.application",
  description: "popup.payment.success.description",
  button: "",
};

export const FAILED_PAGE = {
  icon: <FailedIcon />,
  header: "popup.payment.failed.title",
  description: "popup.payment.failed.description",
  button: "profile.balance.deposit.transaction.failed.button",
};

export const WAIT_PAGE = {
  icon: <WaitIcon />,
  header: "",
  description: "",
  button: "",
};

export const ATTENTION_PAGE = {
  icon: <AttentionIcon />,
  header: "",
  description: "",
  button: "",
};

export const BANKS_SPAYZ: SelectOptionProps[] = [
  {
    id: BANKS_SPAYZ_ENUM.BUSANBANK,
    name: "Busan Bank",
    image: Busan,
  },
  {
    id: BANKS_SPAYZ_ENUM.CITIBANK,
    name: "Citibank Korea",
    image: Citibank,
  },
  {
    id: BANKS_SPAYZ_ENUM.CREDITUNION,
    name: "Credit Union",
    image: CreditUnion,
  },
  {
    id: BANKS_SPAYZ_ENUM.DAEGUBANK,
    name: "Daegu Bank",
    image: Daegu,
  },
  {
    id: BANKS_SPAYZ_ENUM.SAVINGSBANK,
    name: "dmsgod Mutual Savings Bank",
    image: Savings,
  },
  {
    id: BANKS_SPAYZ_ENUM.IBK,
    name: "IBK",
    image: IBKBank,
  },
  {
    id: BANKS_SPAYZ_ENUM.JEJUBANK,
    name: "Jeju Bank",
    image: Jeju,
  },
  {
    id: BANKS_SPAYZ_ENUM.JEONBUKBANK,
    name: "Jeonbuk Bank",
    image: Jeonbuk,
  },
  {
    id: BANKS_SPAYZ_ENUM.KAKAOBANK,
    name: "Kakao Bank",
    image: Kakao,
  },
  {
    id: BANKS_SPAYZ_ENUM.KBANK,
    name: "K Bank",
    image: KBank,
  },
  {
    id: BANKS_SPAYZ_ENUM.KDB,
    name: "KDB",
    image: KDB,
  },
  {
    id: BANKS_SPAYZ_ENUM.KEB,
    name: "KEB",
    image: KEB,
  },
  {
    id: BANKS_SPAYZ_ENUM.KEBHANABANK,
    name: "KEB Hana Bank",
    image: KEBHana,
  },
  {
    id: BANKS_SPAYZ_ENUM.KYUNGAMBANK,
    name: "Kyungnam Bank",
    image: Kyungnam,
  },
  // {
  //   id: BANKS_SPAYZ_ENUM.KOOKMINBANK,
  //   name: "Kookmin Bank",
  //   image: Kookmin,
  // },
  {
    id: BANKS_SPAYZ_ENUM.KWANGJU,
    name: "Kwangju Bank",
    image: Kwanguju,
  },
  {
    id: BANKS_SPAYZ_ENUM.KYONGNAM,
    name: "KYONGNAM bank",
    image: Kyongnam,
  },
  {
    id: BANKS_SPAYZ_ENUM.AGRICALTURAL,
    name: "National Agricultural cooperative federation",
    image: Agricultural,
  },
  {
    id: BANKS_SPAYZ_ENUM.NACUFOK,
    name: "NACUFOK (shinhyup)",
    image: Nacufok,
  },
  {
    id: BANKS_SPAYZ_ENUM.NH,
    name: "NH (Jiyeok Nonghyup)",
    image: NH,
  },
  {
    id: BANKS_SPAYZ_ENUM.NONGHYUP,
    name: "Nonghyup Bank",
    image: Nonghyup,
  },
  {
    id: BANKS_SPAYZ_ENUM.POST,
    name: "Post Bank",
    image: Post,
  },
  {
    id: BANKS_SPAYZ_ENUM.SAEMAEUL,
    name: "Saemaeul Bank",
    image: Saemaeul,
  },
  {
    id: BANKS_SPAYZ_ENUM.SC,
    name: "SC First Bank",
    image: SC,
  },
  {
    id: BANKS_SPAYZ_ENUM.SHINHAN,
    name: "Shinhan Bank",
    image: Shinhan,
  },
  {
    id: BANKS_SPAYZ_ENUM.SUHYUP,
    name: "Suhyup Bank",
    image: Suhyup,
  },
  {
    id: BANKS_SPAYZ_ENUM.TOSS,
    name: "Toss Bank",
    image: Toss,
  },
  {
    id: BANKS_SPAYZ_ENUM.WOORI,
    name: "Woori Bank",
    image: Woori,
  },
];
